const BASE_URL = 'cities'

export default {
  GET_CITIE: `/${BASE_URL}`,
  GET_CITIES: `/${BASE_URL}`,
}
